module.exports = __webpack_public_path__ + "static/media/getReadyExam.ba3628db.png";